import {
    missingCertificateDialogText,
    missingCertificateDialogSubText,
} from './MissingCertificateDetails.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

interface MissingCertificateDetailsProps {
    recipientsToDisplay: EmailAddressWrapper[];
}

const styles = require('./MissingCertificateDialog.scss');

const MAX_RECIPIENTS_TO_DISPLAY = 20;

/**
 * Component which displays the recipients with
 * missing encryption certificates.
 * @param props props which contains recipients to be displayed on the dialog
 */
const MissingCertificateDetails = (props: MissingCertificateDetailsProps): JSX.Element => {
    const { recipientsToDisplay } = props;
    const recipients = recipientsToDisplay
        .slice(0, MAX_RECIPIENTS_TO_DISPLAY + 1)
        .map(recipient => recipient.Name)
        .join(', ');
    return (
        <>
            <div className={styles.missingCertificatesDetailsRow}>{recipients}</div>
            <div className={styles.missingCertificatesDetailsRow}>
                {loc(missingCertificateDialogText)}
            </div>
            <div className={styles.missingCertificatesDetailsRow}>
                {loc(missingCertificateDialogSubText)}
            </div>
        </>
    );
};

export default MissingCertificateDetails;
